export default __webpack_public_path__ + "static/media/us-market-cloud.da1b727d.png";